// add title on svg-icon links
document.querySelectorAll('a > svg desc').forEach(function(desc) {
	var link = desc.closest('a');
	if (link.childElementCount !== 1) {
		return;
	}
	var currentTitle = link.getAttribute('title');
	if (currentTitle && currentTitle.indexOf('Rubrique active') !== -1) {
		return;
	}
	var description = desc.textContent;
	var newTitle = currentTitle && currentTitle.length
		? description + ' - ' + currentTitle
		: description;
	link.setAttribute('title', newTitle);
});

// add title on links opening new tabs
document.querySelectorAll('a[target="_blank"]').forEach(function(link) {
	var currentTitle = link.getAttribute('title');
	var newWindowText = ' (nouvelle fenêtre)';
	var newTitle = currentTitle && currentTitle.length
		? currentTitle + newWindowText
		: link.textContent + newWindowText;
	link.setAttribute('title', newTitle);
});
